/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const RES_ID_DELIMITER = '__';
export const PREFIX = `TREE_PERMIT_`;
export const IMG_PREFIX = `${process.env.CDN}/img`;

// prop path constants
export const PERMIT_HOLDER_PROP_PATH = 'PERMIT_HOLDER_PROP_PATH';
export const PERMIT_HOLDER_FIRST_NAME_PROP_PATH = 'PERMIT_HOLDER_FIRST_NAME_PROP_PATH';
export const PERMIT_HOLDER_LAST_NAME_PROP_PATH = 'PERMIT_HOLDER_LAST_NAME_PROP_PATH';
export const PERMIT_HOLDER_EMAIL_PROP_PATH = 'PERMIT_HOLDER_EMAIL_PROP_PATH';
export const PERMIT_HOLDER_PASS_TYPE_PROP_PATH = 'PERMIT_HOLDER_PASS_TYPE_PROP_PATH';
export const PERMIT_HOLDER_PASS_ID_PROP_PATH = 'PERMIT_HOLDER_PASS_ID_PROP_PATH';
export const NEED_TO_KNOW_CHECKED_PROP_PATH = 'NEED_TO_KNOW_CHECKED_PROP_PATH';
export const RESERVATION_FEE = 2.5;
export const DATE_FORMAT = 'ddd, ll';
export const Durations = {
    seasonal: {
        name: 'Seasonal',
        validLength: 'Seasonal',
        days: -1,
        endEndOfMonth: false,
    },
    season: {
        name: 'Seasonal',
        validLength: 'Seasonal',
        days: -1,
        endEndOfMonth: false,
    },
};
export const PRICE_MAGNITUDE = 100000;

// cart
export const ReservationPointsOfSale = ['web', 'field'];
export const ReservationStatuses = ['pending', 'deleted', 'completed'];

// account
export const TREE_PERMIT_INVENTORY = 'TREE_PERMIT';
